// extracted by mini-css-extract-plugin
export var navbarDividedLeft = "x_gN g_gN g_cD g_cL g_cM";
export var navbarDividedRight = "x_gP g_gP g_cD g_cM";
export var menuLeft = "x_r0 g_gL g_cD g_fz g_cS g_cM";
export var menuRight = "x_r1 g_gL g_cD g_fz g_cS g_cM";
export var menuCenter = "x_r2 g_gM g_gL g_cD g_fz g_cS g_bD g_cH g_cM";
export var menuDivided = "x_n5 g_gM g_gL g_cD g_fz g_cS g_bD g_cH";
export var navbarItem = "x_n6 g_cB";
export var navbarLogoItemWrapper = "x_gT g_gT g_cG g_cS";
export var burgerToggleVisibleOpen = "x_r3 g_g7 g_cC g_b5 g_cw";
export var burgerToggleVisible = "x_r4 g_g7 g_cC g_b5 g_cw";
export var burgerToggle = "x_r5 g_g7 g_cC g_b5 g_cw g_b5";
export var burgerToggleOpen = "x_r6 g_g7 g_cC g_b5 g_cw g_b9";
export var burgerInput = "x_r7 g_gY g_bD g_bP g_cC g_dg g_fp g_cl g_b6 g_cg g_cf g_cb g_ch";
export var burgerLine = "x_r8 g_gX";
export var burgerMenuLeft = "x_r9 g_g2 g_g1 g_gZ g_g0 g_b6 g_dg g_fq g_cw g_fz";
export var burgerMenuRight = "x_sb g_g3 g_g1 g_gZ g_g0 g_b6 g_dg g_fq g_cw g_fz";
export var burgerMenuCenter = "x_sc g_g4 g_g1 g_gZ g_g0 g_b6 g_dg g_fq g_cw g_fz";
export var burgerMenuDivided = "x_sd g_g2 g_g1 g_gZ g_g0 g_b6 g_dg g_fq g_cw g_fz";
export var secondary = "x_sf g_cG g_cS";
export var staticBurger = "x_sg";
export var menu = "x_sh";
export var navbarDividedLogo = "x_sj";
export var nav = "x_sk";